var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.85,
    y: 5.85,
    width: 14.3,
    height: 11.3,
    rx: 2.15,
    stroke: "#227BEF",
    strokeWidth: 1.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6L5.74856 10.3714C5.90042 10.751 6.26813 11 6.67703 11H13.323C13.7319 11 14.0996 10.751 14.2514 10.3714L16 6",
    stroke: "#227BEF",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85 5C6.85 3.81259 7.81259 2.85 9 2.85H11C12.1874 2.85 13.15 3.81259 13.15 5V5.65H6.85V5Z",
    stroke: "#227BEF",
    strokeWidth: 1.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIconBlue);
export default __webpack_public_path__ + "static/media/work_icon_blue.82ac147c971d7f5a51b7db29f51db915.svg";
export { ForwardRef as ReactComponent };